import { makeStyles } from '@material-ui/core/styles'

const styles = makeStyles(theme => ({
  button: {
    flexGrow: 0,
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    color: 'white',
    height: 56,
    fontSize: 27,
    borderRadius: 30,
    '@media (max-width: 1024px)': {
      height: 44,
      fontSize: 22
    }
  },
  pulseRing: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    borderRadius: '100px',
    borderRadus: '100%',
    transition:
      'opacity 600ms,transform 600ms cubic-bezier(0.215, 0.61, 0.355, 1)'
  },
  bidGlow: {
    position: 'absolute',
    height: '100%',
    background: 'rgba(255, 255, 255, 0.3)',
    borderRadius: '100px'
  }
}))

export default styles



// WEBPACK FOOTER //
// ./src/components/EngagementButtons/Button/styles.js